import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend, localize, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


function loadLocale(code) {
  return import(`vee-validate/dist/locale/${code}.json`).then(locale => {
    localize(code, locale);
  });
}
loadLocale('en');


Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});


extend('todayAndFuture', {
  validate: value => {
    let tmr = new Date()
    tmr.setDate(tmr.getDate() - 1)
    return new Date(value) >= tmr
  },
  message: "Cannot accept date in the past."
});

extend('afterNow', {
  validate: value => {
    let date = new Date(value)
    let newDate = new Date()
    return date.getTime() > newDate.getTime()
  },
  message: "Please enter a date after today."
});

extend('afterDate', {
  validate(value, args) {
    let date = new Date(value)
    let beforeDate = new Date(args.beforeDate)
    return date.getTime() > beforeDate.getTime()
  },
  params: ['beforeDate'],
  message: "End date should be later than start date."
});

/*extend('twoArraysNotEmpty', {
  validate(value, args) {
    console.log("value:", value)
    console.log("args.otherArrayLength:", args.otherArrayLength)
    return value.length <= 0 && parseInt(args.otherArrayLength) <= 0
  },
  params: ['otherArrayLength'],
  message: "At least one {_field_} is required."
});*/

extend('maxTwoWeeks', {
  validate(value, args) {
    //console.log(args)
    return !args.isValid
  },
  params: ['isValid'],
  message: "If the student will not ride for more than 2 weeks, then submit a cancel request instead."
});

extend('required', {
  validate(value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true,
  message: "The {_field_} is required"
});

extend('beforeNowTime', {
  validate(value) {
    let now = new Date()
    let suppliedTime = new Date()
    suppliedTime.setHours(
      parseInt(value.slice(0, 2)),
      parseInt(value.slice(3, 5)),
      0,
      0,
    )
    return now > suppliedTime
  },
  message: "Cannot accept time in the future.",
});

extend('nameCheck', {
  validate(value) {
    return !/[`!@#$%^&*_+=[\]{};:"\\|<>/?~]/.test(value)
  },
  message: "The {_field_} is invalid"
});

extend('emailCheck', {
  validate(value) {
    // validates email using RFC 5322 format - see https://stackabuse.com/validate-email-addresses-with-regular-expressions-in-javascript/
    // eslint-disable-next-line no-control-regex, no-useless-escape
    //let regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
    //return regex.test(value)

    // attempts to match Python Django's REST Framework EmailField regex validation
    return /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/.test(value)
    //return /^[\w.-]+@[\w.-]+\.\w+$/.test(value)
  },
  message: "The {_field_} is invalid"
});

extend('phoneCheck', {
  validate(value) {
    return /^[(][0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/im.test(value)
    //return !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(value)
  },
  message: "The {_field_} is invalid"
});

extend('zipCodeCheck', {
  validate(value) {
    return /^[0-9]{5}$/.test(value)
  },
  message: "The {_field_} is invalid"
});

// district student ids must match
extend('matchDistStudIds', {
  validate(value, args) {
    return value == args.distStudId
  },
  params: ['distStudId'],
  message: "The confirmation must match the district student ID"
});

extend('isChecked', {
  validate(value) {
    return value == true
  },
  message: "The checkbox must be checked"
})

extend('minGrade', {
  validate(_, args){
    return Number(args[1]) >= Number(args[0])
  },
  message: "The high grade cannot be lower than the low grade"
})

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
    // ...
  }
})